import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../api/api/user.service';
import { ProfileService } from '../../core/profile/profile.service';
import { LoadingService } from '../loading/loading.service';
import { TranslateService } from './../../core/translation';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';

export type ThemeMode = 'light' | 'dark';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss'],
  providers: [UserService]
})

export class LanguagesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('beforeMenu') menu: MatMenuTrigger;

  @Input() forceReload: boolean = true;
  @Input() mode: ThemeMode = 'light';
  @Input() selectedLang: string;

  /**
   * Array containing languages.
   */
  languages: {
    label: string;
    value: string;
    shortLabel: string;
  }[] = [];

  /**
   * Object containing the keys and labels for languages.
   */
  labels: { [key: string]: string } = {
    'ca': 'lang_ca',
    'en': 'lang_en',
    'fr': 'lang_fr',
    'es': 'lang_es',
    'pt': 'lang_pt'
  };

  shortLabels: { [key: string]: string } = {
    'ca': 'CAT',
    'en': 'EN',
    'fr': 'FR',
    'es': 'ES',
    'pt': 'PT'
  };

  /**
   * String containing the selected language.
   */
  selected: string = null;
  _transParam = false;
  translationPrefix: string;
  isMenuOpen: boolean = false;
  token: string;

  destroy$: Subject<boolean> = new Subject<boolean>();
  
  constructor(
    public _translate: TranslateService,
    public _profile: ProfileService,
    private _user: UserService,
    private _loading: LoadingService) { }

  ngOnInit(): void {
    this.token = this._profile.getToken();
    this.languages = this._translate.activeLanguages.map(
      (option: string) => {
        return { label: this.labels[option], value: option, shortLabel: this.shortLabels[option] };
      }
    );
    TranslateService.initTranslateSubscription(this);
  }

  ngAfterViewInit(): void {
    this.languages.sort((a, b) => a.label.localeCompare(b.label))
    this.selected = this.selectedLang ?? this._translate.lang;
    this.translationPrefix = 'topbar.prefix_' + this.selected;
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
   }

  /**
   * Function that sets the selected language in the translate service.
   * @param {string} value String containing the selected language.
   */
  async change(value: string): Promise<void> {
    const sessionUser = this._profile.getToken();
    this.selected = value;
    this.translationPrefix = 'topbar.prefix_' + value;
    this._translate.set(value);

    if (sessionUser) {
      const response = await this._user.userChangeActiveLanguage(value, sessionUser).toPromise();
      this._loading.set(false);
      
      if (response.data && this.forceReload) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } else if (this.forceReload) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
    document.cookie = 'lang=' + value + ';path=/;';
  }

  onClickSelect($event: any): void {
    $event.stopPropagation();
  }

}
